import type { AddPvdConfigRequest } from '@/../generated-client/models';

const VOLTAGE_CHIP_COUNT = 22;
const CURRENT_CHIP_COUNT = 11;

/**
 * SA min/max default span. Voltage defaults to the full 1..22 chip strip.
 * Current defaults to the full 1..11 span.
 */
const VOLTAGE_DEFAULT_MIN = 1;
const VOLTAGE_DEFAULT_MAX = 22;
const CURRENT_DEFAULT_MIN = 1;
const CURRENT_DEFAULT_MAX = 11;

const BUBBLE_SIZE_DEFAULT_LOCKED_TO_VALUE = false; // Spec D18: false = small; ignored when is_locked is false.

/**
 * Default leaning per SA discussion notes §6: user-defined controls enabled
 * by default. All `*_is_locked` fields default to false so workers retain
 * control until an admin explicitly locks something down.
 */
export function createDefaultPvdConfig(): AddPvdConfigRequest {
  return {
    org_code: '',
    spec_name: '',
    is_compass_core: false,
    voltage_allowed_settings: Array(VOLTAGE_CHIP_COUNT).fill(true),
    adaptive_voltage_allowed: true,
    current_allowed_settings: Array(CURRENT_CHIP_COUNT).fill(true),
    adaptive_current_allowed: true,

    adaptive_shared_auto_adapt_is_locked: false,
    adaptive_shared_auto_adapt_locked_to_value: true,

    adaptive_voltage_next_alert_size_is_locked: false,
    adaptive_voltage_next_alert_size_locked_to_value: BUBBLE_SIZE_DEFAULT_LOCKED_TO_VALUE,
    adaptive_voltage_min_setting: VOLTAGE_DEFAULT_MIN,
    adaptive_voltage_max_setting: VOLTAGE_DEFAULT_MAX,

    adaptive_current_next_alert_size_is_locked: false,
    adaptive_current_next_alert_size_locked_to_value: BUBBLE_SIZE_DEFAULT_LOCKED_TO_VALUE,
    adaptive_current_min_setting: CURRENT_DEFAULT_MIN,
    adaptive_current_max_setting: CURRENT_DEFAULT_MAX,

    should_force_apply_this_update: false,
  };
}
